import { render, staticRenderFns } from "./transcript-participants.vue?vue&type=template&id=34236998&scoped=true&"
import script from "./transcript-participants.vue?vue&type=script&lang=js&"
export * from "./transcript-participants.vue?vue&type=script&lang=js&"
import style0 from "./transcript-participants.vue?vue&type=style&index=0&id=34236998&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34236998",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VBtn,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34236998')) {
      api.createRecord('34236998', component.options)
    } else {
      api.reload('34236998', component.options)
    }
    module.hot.accept("./transcript-participants.vue?vue&type=template&id=34236998&scoped=true&", function () {
      api.rerender('34236998', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/crm/components/transcript-participants/transcript-participants.vue"
export default component.exports